import React from "react";
import "./TermsOfUse.css";

function TermsOfUse() {
  return (
    <section className="termsPage">
      <div className="termsPage-container">
        <h1 className="termsPage-title">Terms of Use</h1>

        <p className="termsPage-text">
          Welcome to Jaltaara Resort. By accessing or using our website, you
          agree to comply with the following terms and conditions. Please read
          them carefully before using our services.
        </p>

        <h3 className="termsPage-heading">1. Acceptance of Terms</h3>
        <p className="termsPage-text">
          By using this website, you confirm that you are at least 18 years old
          and legally capable of entering into a binding agreement. If you do
          not agree to these terms, please refrain from using the site.
        </p>

        <h3 className="termsPage-heading">2. Booking & Payments</h3>
        <p className="termsPage-text">
          All bookings made through our website are subject to availability.
          Prices may vary based on season, room type, or promotional offers.
        </p>

        <h3 className="termsPage-heading">3. Use of Website</h3>
        <p className="termsPage-text">
          You agree not to misuse, modify, or attempt to hack any part of the
          website or services provided.
        </p>

        <h3 className="termsPage-heading">4. Intellectual Property</h3>
        <p className="termsPage-text">
          All images, text, and content on this website are the property of
          Jaltaara Resort and cannot be copied or redistributed without written
          permission.
        </p>

        <h3 className="termsPage-heading">5. Changes to Terms</h3>
        <p className="termsPage-text">
          Jaltaara Resort reserves the right to update these terms at any time.
          Continued use of the website indicates acceptance of these changes.
        </p>
      </div>
    </section>
  );
}

export default TermsOfUse;
